<!-- Div used for buttons. Is not a button itself in case we want it to be in an anchor tag -->
<template>
	<div
		class="~@lg/2xl:~px-4/8 ~@lg/2xl:~py-2/3.5 ~@lg/2xl:~text-sm/xl flex w-full cursor-pointer justify-center rounded-md"
		:class="[
			{
				'text-secondary-400 pointer-events-none border-slate-400 bg-slate-200':
					disabled,
				'pointer-events-none border-transparent': success,
			},
		]"
	>
		<slot></slot>
	</div>
</template>

<script setup lang="ts">
defineProps({
	disabled: { type: Boolean, default: false },
	success: { type: Boolean, default: false },
})
</script>
